/* Neuer Header (kjxn): Mega-Panels (Hover mit Verzögerung, Klick, Tastatur), Suche mit Vorschlägen, Handy-Schublade. */
(function () {
  var root = document.querySelector('[data-kjxn]');
  if (!root) return;
  var dim = root.querySelector('[data-kjxn-dim]');
  var desk = window.matchMedia('(min-width: 990px)');
  var hoverable = window.matchMedia('(hover: hover)');

  /* ── Mega-Panels ── */
  var items = [].slice.call(root.querySelectorAll('[data-kjxn-item]'));
  var openItem = null, tOpen, tClose;
  function setDim(on) { if (dim) dim.hidden = !on; }
  function openPanel(li) {
    if (openItem === li) return;
    closePanel(true);
    openItem = li;
    li.classList.add('is-open');
    li.querySelector('.kjxn-top-a').setAttribute('aria-expanded', 'true');
    closeSearch();
    setDim(true);
  }
  function closePanel(keepDim) {
    if (!openItem) return;
    openItem.classList.remove('is-open');
    openItem.querySelector('.kjxn-top-a').setAttribute('aria-expanded', 'false');
    openItem = null;
    if (!keepDim) setDim(false);
  }
  items.forEach(function (li) {
    var a = li.querySelector('.kjxn-top-a');
    li.addEventListener('mouseenter', function () {
      if (!desk.matches || !hoverable.matches) return;
      clearTimeout(tClose);
      tOpen = setTimeout(function () { openPanel(li); }, openItem ? 0 : 120);
    });
    li.addEventListener('mouseleave', function () {
      if (!desk.matches || !hoverable.matches) return;
      clearTimeout(tOpen);
      tClose = setTimeout(function () { if (openItem === li) closePanel(); }, 180);
    });
    /* Touch-Geräte mit großem Bildschirm: erster Tipp öffnet, zweiter folgt dem Link */
    a.addEventListener('click', function (e) {
      if (!desk.matches) return;
      if (!hoverable.matches && openItem !== li) { e.preventDefault(); openPanel(li); }
    });
    a.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && openItem !== li)) {
        e.preventDefault(); openPanel(li);
        var first = li.querySelector('.kjxn-panel a'); if (first) first.focus();
      }
    });
    li.addEventListener('focusout', function () {
      setTimeout(function () { if (openItem === li && !li.contains(document.activeElement)) closePanel(); }, 0);
    });
  });
  if (dim) dim.addEventListener('click', function () { closePanel(); closeSearch(); });

  /* ── Suche ── */
  var search = root.querySelector('[data-kjxn-search]');
  var q = root.querySelector('[data-kjxn-q]');
  var sugg = root.querySelector('[data-kjxn-sugg]');
  var openBtn = root.querySelector('[data-kjxn-search-open]');
  function openSearch() {
    closePanel(true);
    search.hidden = false; setDim(true);
    openBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { q.focus(); }, 30);
  }
  function closeSearch() {
    if (!search || search.hidden) return;
    search.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
    if (!openItem) setDim(false);
  }
  if (openBtn) openBtn.addEventListener('click', function () { search.hidden ? openSearch() : closeSearch(); });
  var closeBtn = root.querySelector('[data-kjxn-search-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { closeSearch(); openBtn.focus(); });

  var timer, ctrl;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  if (q) q.addEventListener('input', function () {
    clearTimeout(timer);
    var term = q.value.trim();
    if (term.length < 2) { sugg.innerHTML = ''; return; }
    timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!ps.length) { sugg.innerHTML = '<p>Keine Treffer für „' + esc(term) + '“.</p>'; return; }
        sugg.innerHTML = ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var price = p.price ? Number(p.price).toFixed(2).replace('.', ',') + ' €' : '';
          return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') +
            '<span>' + esc(p.title) + '</span><b>' + price + '</b></a>';
        }).join('') + '<a class="kjxn-sugg-all" href="/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">Alle Ergebnisse für „' + esc(term) + '“</a>';
      }).catch(function () {});
    }, 180);
  });

  /* ── Handy-Schublade ── */
  var drawer = root.querySelector('[data-kjxn-drawer]');
  var burger = root.querySelector('[data-kjxn-open]');
  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('kjxn-lock');
    burger.setAttribute('aria-expanded', 'true');
    setDim(true);
    var c = drawer.querySelector('[data-kjxn-close]'); if (c) c.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open', 'is-sub');
    [].slice.call(drawer.querySelectorAll('.kjxn-dr-sub.is-on')).forEach(function (s) { s.classList.remove('is-on'); });
    document.documentElement.classList.remove('kjxn-lock');
    burger.setAttribute('aria-expanded', 'false');
    setDim(false);
    setTimeout(function () { drawer.hidden = true; }, 260);
    burger.focus();
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelector('[data-kjxn-close]').addEventListener('click', closeDrawer);
    [].slice.call(drawer.querySelectorAll('[data-kjxn-sub]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = document.getElementById(b.getAttribute('data-kjxn-sub'));
        if (!sub) return;
        sub.hidden = false; sub.scrollTop = 0;
        requestAnimationFrame(function () { sub.classList.add('is-on'); drawer.classList.add('is-sub'); });
        var back = sub.querySelector('[data-kjxn-back]'); if (back) setTimeout(function () { back.focus(); }, 250);
      });
    });
    [].slice.call(drawer.querySelectorAll('[data-kjxn-back]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var sub = b.closest('.kjxn-dr-sub');
        sub.classList.remove('is-on'); drawer.classList.remove('is-sub');
        var opener = drawer.querySelector('[data-kjxn-sub="' + sub.id + '"]'); if (opener) opener.focus();
      });
    });
  }
  if (dim) dim.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    else if (search && !search.hidden) { closeSearch(); openBtn.focus(); }
    else if (openItem) { var a = openItem.querySelector('.kjxn-top-a'); closePanel(); a.focus(); }
  });
  desk.addEventListener && desk.addEventListener('change', function () { closePanel(); closeDrawer(); });
})();
